export class SystemUserType {
  systemUserTypeId?: number;
  isChecked?: boolean;
  //programId?: number = 0;
  userTypeName: string;
  userTypeNameEn: string;
  userTypeIconUrl: string;
  schoolIds: number[] = [];
  applyOnAllSchool: boolean = false;
}
